import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "k3 loseinfo"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "和值", -1);

const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "两面", -1);

const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];

const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "跨度", -1);

const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "theme-border-half",
  style: {
    "padding": "3px 7px",
    "margin-top": "3px",
    "border": "1px solid"
  }
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 总投注额： ");

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 最高亏损： ");

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 最高盈利： ");

const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "三军", -1);

const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];

const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "红黑", -1);

const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];

const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "红黑码", -1);

const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];

const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "组六", -1);

const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];

const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "三同号通选", -1);

const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["onClick"];

const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "三同号单选", -1);

const _hoisted_47 = ["onClick"];
const _hoisted_48 = ["onClick"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = ["onClick"];

const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "三连号通选", -1);

const _hoisted_52 = ["onClick"];
const _hoisted_53 = ["onClick"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = ["onClick"];

const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "三不同号", -1);

const _hoisted_57 = ["onClick"];
const _hoisted_58 = ["onClick"];
const _hoisted_59 = ["onClick"];
const _hoisted_60 = ["onClick"];

const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "二同号复选", -1);

const _hoisted_62 = ["onClick"];
const _hoisted_63 = ["onClick"];
const _hoisted_64 = ["onClick"];
const _hoisted_65 = ["onClick"];

const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "二同号单选", -1);

const _hoisted_67 = ["onClick"];
const _hoisted_68 = ["onClick"];
const _hoisted_69 = ["onClick"];
const _hoisted_70 = ["onClick"];

const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "二不同号", -1);

const _hoisted_72 = ["onClick"];
const _hoisted_73 = ["onClick"];
const _hoisted_74 = ["onClick"];
const _hoisted_75 = ["onClick"];
const _hoisted_76 = {
  class: "title theme-border-half light-bg"
};

const _hoisted_77 = /*#__PURE__*/_createTextVNode(" 总额： ");

const _hoisted_78 = {
  class: "theme-text"
};
const _hoisted_79 = {
  class: "theme-text num"
};

const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "两面长龙", -1);

const _hoisted_81 = /*#__PURE__*/_createTextVNode("暂无数据");

const _hoisted_82 = {
  class: "theme-text num"
};
const _hoisted_83 = {
  ref: "pl_popver",
  class: "pl_popver"
};
const _hoisted_84 = {
  class: "pl_popver_title"
};
const _hoisted_85 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_86 = /*#__PURE__*/_createTextVNode(" 赔率： ");

const _hoisted_87 = {
  style: {
    "margin": "10px",
    "text-align": "center"
  }
};

const _hoisted_88 = /*#__PURE__*/_createTextVNode("  取消  ");

const _hoisted_89 = /*#__PURE__*/_createTextVNode("  确认  ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    gutter: 2
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 2
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_table, {
            data: $data.hz,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号码",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_4), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_6)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_7, _createVNode(_component_el_table, {
            data: $data.lm,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号码",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_9), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_10)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_11)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_12, _createVNode(_component_el_table, {
            data: $data.kd,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号码",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_14), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_15)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_16)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"]), _createElementVNode("div", _hoisted_17, [_createElementVNode("p", null, [_hoisted_18, _createElementVNode("span", null, _toDisplayString($props.sum.all_balance), 1)]), _createElementVNode("p", null, [_hoisted_19, _createElementVNode("span", null, _toDisplayString($data.max_ks), 1)]), _createElementVNode("p", null, [_hoisted_20, _createElementVNode("span", null, _toDisplayString($data.max_yl), 1)])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_21, _createVNode(_component_el_table, {
            data: $data.sj,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号码",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_22)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_23), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_24)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_25)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_hoisted_26, _createVNode(_component_el_table, {
            data: $data.hh,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号码",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_27)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_28), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_29)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_30)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_31, _createVNode(_component_el_table, {
                data: $data.hhm,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "45"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_32)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_33), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_34)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_35)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_36, _createVNode(_component_el_table, {
                data: $data.z6,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_37)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_38), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_39)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_40)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_41, _createVNode(_component_el_table, {
                data: $data.sthtx,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_42)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_43), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_44)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_45)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_46, _createVNode(_component_el_table, {
                data: $data.sthdx,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_47)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_48), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_49)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_50)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_51, _createVNode(_component_el_table, {
                data: $data.slhtx,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_52)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_53), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_54)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_55)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_56, _createVNode(_component_el_table, {
                data: $data.sbth,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_57)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_58), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_59)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_60)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_61, _createVNode(_component_el_table, {
                data: $data.ethfx,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_62)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_63), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_64)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_65)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_66, _createVNode(_component_el_table, {
                data: $data.ethdx,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_67)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_68), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_69)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_70)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_71, _createVNode(_component_el_table, {
                data: $data.ebth,
                border: "",
                size: "small",
                "highlight-current-row": "",
                "header-cell-class-name": "table-header-cell",
                "header-row-class-name": "table-header-row",
                "table-layout": "auto"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  property: "name",
                  label: "号码",
                  align: "center",
                  width: "40"
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "赔率",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "plus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                  }, null, 8, _hoisted_72)) : _createCommentVNode("", true), _createElementVNode("span", {
                    class: "item-pl",
                    onClick: $event => $options.show_pl_popver(scope.row, $event)
                  }, _toDisplayString(scope.row.pl), 9, _hoisted_73), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "minus",
                    onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                  }, null, 8, _hoisted_74)) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "注额",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => $options.get_zdmx_data(scope.row)
                  }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_75)]),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  property: "title",
                  label: "盈亏",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createElementVNode("span", {
                    style: _normalizeStyle({
                      color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                    })
                  }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 2
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_76, [_hoisted_77, _createElementVNode("span", _hoisted_78, _toDisplayString($props.sum.all_balance), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sum.sums, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "cl-item theme-border-half light-bg",
              key: item.index
            }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_79, _toDisplayString(item.all_balance), 1)]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_hoisted_80, $props.chang_long.length == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_81], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList($props.chang_long, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "cl-item theme-border-half light-bg",
              key: item.index
            }, [_createTextVNode(_toDisplayString(item.title) + "-" + _toDisplayString(item.name) + " ", 1), _createElementVNode("span", _hoisted_82, _toDisplayString(item.b_s_qnum) + "期", 1)]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _withDirectives(_createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, "修改赔率:" + _toDisplayString($data.pl_popver.row.name), 1), _createElementVNode("div", null, [_createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.pl_popver.value), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_85, [_hoisted_86, _createVNode(_component_el_input, {
    style: {
      "width": "80px"
    },
    modelValue: $data.pl_popver.pl_change_value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pl_popver.pl_change_value = $event),
    size: "small",
    min: "0"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_87, [_createVNode(_component_el_button, {
    size: "small",
    onClick: _cache[1] || (_cache[1] = $event => $data.pl_popver.show = false)
  }, {
    default: _withCtx(() => [_hoisted_88]),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: $options.sub_change_pl
  }, {
    default: _withCtx(() => [_hoisted_89]),
    _: 1
  }, 8, ["onClick"])])], 512), [[_vShow, $data.pl_popver.show]])]);
}